import { lazy } from "react";
const inventoryManagement = lazy(() => import("./inventory-management"));

const inventoryManagementRoutes = [
    {
        path : '/sop/petty-cash-procedures',
        component : inventoryManagement

    }
];

export default inventoryManagementRoutes;